"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("./constants");
var StickyFooter = /** @class */ (function (_super) {
    __extends(StickyFooter, _super);
    function StickyFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StickyFooter.prototype.init = function () {
        var _this = this;
        this.setSelector(constants_1.DATA_FOOTER);
        if (this.getElement() === null) {
            return;
        }
        var footerFirstElement = this.getElement().querySelector("[".concat(constants_1.DATA_FOOTER_FIRST, "]"));
        var footerFirstHeight = footerFirstElement.offsetHeight;
        var footerSecondElement = this.getElement().querySelector("[".concat(constants_1.DATA_FOOTER_SECOND, "]"));
        var footerSecondHeight = footerSecondElement.offsetHeight;
        if (window.innerWidth >= constants_1.WINDOW_BREAKPOINT_LG) {
            document.body.style.paddingBottom = footerFirstHeight + footerSecondHeight + 'px';
            window.onscroll = function () {
                var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                var scrollTopEnd = document.body.clientHeight - document.documentElement.clientHeight;
                if (scrollTop > 1 / 3 * scrollTopEnd) {
                    _this.getElement().style.bottom = -footerSecondHeight + 'px';
                }
                else {
                    _this.getElement().style.bottom = -(footerFirstHeight + footerSecondHeight) + 'px';
                }
                if (scrollTop > 7 / 8 * scrollTopEnd) {
                    _this.getElement().style.bottom = '0px';
                }
            };
        }
        else {
            document.body.style.paddingBottom = '0px';
        }
    };
    return StickyFooter;
}(abstractComponent_1.default));
exports.default = StickyFooter;
